import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appAutoTab]'
})
export class AutoTabDirective {
  constructor(private el: ElementRef<HTMLInputElement>) {}

  // Handle input to auto-focus the next input when the max length is reached
  @HostListener('input', ['$event.target'])
  onInput(inputElement: HTMLInputElement): void {
    if (inputElement.value.length >= inputElement.maxLength) {
      const nextInput = this.findAdjacentInput(inputElement, 'nextElementSibling');
      nextInput?.focus();
    }
  }

  // Handle backspace to auto-focus the previous input when the input is empty
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    const inputElement = this.el.nativeElement;

    // Check if backspace is pressed and the current input is empty
    if (event.key === 'Backspace' && inputElement.value.length === 0) {
      const previousInput = this.findAdjacentInput(inputElement, 'previousElementSibling');
      previousInput?.focus();
    }
  }

  private findAdjacentInput(
    inputElement: HTMLElement,
    direction: 'nextElementSibling' | 'previousElementSibling'
  ): HTMLInputElement | null {
    let sibling = inputElement[direction];

    while (sibling) {
      if (sibling.tagName === 'INPUT') {
        return sibling as HTMLInputElement;
      }
      sibling = sibling[direction];
    }

    return null;
  }
}
